module.exports = __webpack_public_path__ + "static/media/MakeUpRoomWhite.ebb629d9.svg";